import { Shimmer } from '@wartek-id/shimmer'

import { range } from '@/utils/array'

import { ContainerNoPadding } from '@/components/Container'

export const RoundedTableLoader = ({ rows = 5 }: { rows: number }) => {
  return (
    <div className="py-8" data-testid="div-table-loader">
      <ContainerNoPadding className="rounded-lg">
        <div className="flex w-full flex-col gap-2">
          <Shimmer width="100%" height={80} />

          {range(1, rows).map((item) => (
            <Shimmer
              width={`${item % 2 === 0 ? 50 : 70}%`}
              height={30}
              key={item}
            />
          ))}

          <Shimmer width="90%" height={60} />
        </div>
      </ContainerNoPadding>
    </div>
  )
}
